import { NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import './polyfills';

declare global {
  interface Window {
    ngRef?: NgModuleRef<AppModule>;
  }
}

Sentry.init({
  dsn: 'https://9a7209e7eb738aaab902bdd6cd3975d3@o4508500655472640.ingest.de.sentry.io/4508500656652368',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Sentry
  tracesSampleRate: 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', 'skye-app-api.ilovecode.se', /^https:\/\/.*\.ilovecode\.se/],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((ref: NgModuleRef<AppModule>) => {
    // Ensure Angular destroys itself on hot reloads
    if (window.ngRef) {
      window.ngRef.destroy();
    }
    window.ngRef = ref; // Assign the NgModuleRef to window.ngRef
  })
  .catch(err => console.error('Angular bootstrapping failed: ', err));
